module.exports = __webpack_public_path__ + "static/media/blue.200a719e.png";